import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@rsos/components/capstone/base';
import { VideoPlayer, HLS_EXTENSIONS } from '@rsos/video';
import { NO_PLAYBACK_RATE } from '../CustomVideoRenderer/CustomVideoRenderer';
import './CustomImageRenderer.scss';

const CustomImageRenderer = props => {
  const [viewingThumb, setViewingThumb] = useState(false);
  const { data, schema, path, onZoom } = props;

  const handleZoom = imageURL => {
    onZoom(imageURL);
  };

  const renderMedia = () => {
    if (HLS_EXTENSIONS.test(data.props.src)) {
      return (
        <div className={`depth-${path.length}`}>
          <strong className="default-type-string default-type-string-title">
            {schema.title}
          </strong>
          <Box mx={3}>
            <VideoPlayer
              playerId={`video-${data.props.src}`}
              controls
              src={data.props.src}
              controlsList={NO_PLAYBACK_RATE}
              disablePictureInPicture
            />
          </Box>
        </div>
      );
    } else if (viewingThumb) {
      return (
        <div className={`default-type-string depth-${path.length}`}>
          <strong className="default-type-string-title">{schema.title}</strong>{' '}
          <span className="default-type-string-value">
            <img
              src={data.props.src}
              className="default-type-string-format-image-thumbnail"
              onClick={() => {
                handleZoom(data.props.src);
              }}
            />
          </span>
        </div>
      );
    } else {
      return (
        <Button ml="20px" onClick={() => setViewingThumb(true)}>
          View Image
        </Button>
      );
    }
  };

  return <div className="CustomImageRenderer">{renderMedia()}</div>;
};

CustomImageRenderer.propTypes = {
  data: PropTypes.shape().isRequired,
  schema: PropTypes.shape().isRequired,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  onZoom: PropTypes.func.isRequired,
};

export default CustomImageRenderer;
